if (!customElements.get('mc-gift-card')) customElements.define('mc-gift-card', class extends HTMLElement {
 connectedCallback() {
  if(this.ready)return;this.ready=true;
  const input=this.querySelector('textarea'), button=this.querySelector('button'), status=this.querySelector('[data-status]'), boxMessage=this.querySelector('[data-box-message]');
  input.addEventListener('input',()=>{this.querySelector('[data-count]').textContent=`${input.value.length} / 250 characters`;});
  button.addEventListener('click',async()=>{
   if(button.disabled)return;
   if(!boxMessage.value){status.textContent='Please choose the message inside your gift box.';boxMessage.focus();return;}
   if(input.value.length>250){status.textContent='Please keep your message to 250 characters.';return;}
   button.disabled=true;status.textContent='Adding your gift box…';
   const controller=new AbortController(),timer=setTimeout(()=>controller.abort(),20000);
   try{
    const response=await fetch(this.dataset.url,{method:'POST',headers:{'Content-Type':'application/json'},signal:controller.signal,body:JSON.stringify({items:[{id:Number(this.dataset.variant),quantity:1,properties:{'Internal gift-box message':boxMessage.value,'Gift message':input.value.trim()}}]})});
    const result=await response.json();if(!response.ok)throw new Error(result.description||'Unable to add the gift box.');
    window.location.reload();
   }catch(error){status.textContent=error.name==='AbortError'?'Please refresh your bag to check whether the box was added before trying again.':error.message;if(error.name!=='AbortError')button.disabled=false;}
   finally{clearTimeout(timer);}
  });
 }
});
